import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { certificateActions } from '../../../../../store/actions'
import { addLifecycle, removeLifecycle } from '../../../../../assets/js/native.lifecycle'
import { commons } from '../../../../../hook/common'

const PayMobile = (props) => {
  
   const M = window.M
   
   console.log(props)
  
  /*  useEffect(() => {

    props.openPccRequest() // reqInfo, retUrl 정보인증 요청 하는 axios 호출
    // 초기화
    M.data.removeParam('retInfo')

    const onRestoreEvent = () => {
      const retInfo = M.data.param('retInfo')
      if (retInfo) {
        console.log('retInfo############################', retInfo)
        props.resultPccInfo(retInfo)
        M.data.removeParam('retInfo')
      } else {
        console.log('onRestoreEvent############################')
        props.onChange()
      }
    }

    addLifecycle('onrestore', onRestoreEvent)
    return () => {
      removeLifecycle('onrestore', onRestoreEvent)
    }
  }, []) */

  useEffect(() => {
    if (props.isPMobileOpen === true) {
      M.page.html({
        url: 'https://test-wallet.utradehub.or.kr/payPopupMobile.htm',
        param: {
            EdiDate: props.EdiDate,
            SignData: props.SignData,
            Moid: props.Moid,
            GoodsName: props.GoodsName,
            Amt: props.Amt,
            BuyerName: props.BuyerName,
            BuyerTel: props.BuyerTel,
            BuyerEmail: props.BuyerEmail
        },
        actionType: 'NO_HISTORY',
      })
    }
  }, [props.isPMobileOpen])

 /*  useEffect(() => {
    //reqInfo, retUrl 정보인증 요청 하는 axios 호출
    if (props.certResult === 'Y') {
      console.log('certResult: Y')
      props.onChange()
      // props.error({ title: '확인', message: '본인인증이 정상 인증되었습니다.' })
    } else if (props.certResult === 'N') {
      console.log('certResult: N')
      props.onChange()
      props.error({ title: '확인', message: '본인인증을 실패했습니다.' })
    }
  }, [props.certResult]) */

  return (
    <React.Fragment>
      {/* <form
        id="tranMgr"
        target="exWNStartViewElecDocActivity"
        name="PCCV3WFRM"
        method="post"
        action="https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v2.jsp"
      >
        <input type="hidden" id="verSion" name="verSion" value={'2'} />
        <input type="hidden" id="retUrl" name="retUrl" value={props.pccInfo.retUrl} />
        <input type="hidden" id="reqInfo" name="reqInfo" value={props.pccInfo.reqInfo} />
        <input type="hidden" id="retInfo" name="retInfo" />
      </form> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    pccInfo: state.certificate,
    certResult: state.certificate?.resultInfo?.result,
  }
}

const actionCreators = {
  openPccRequest: certificateActions.openPccRequest,
  resultPccInfo: certificateActions.resultPccInfo,
}

export default connect(mapStateToProps, actionCreators)(PayMobile)
